import { Component, AfterViewInit, NgZone, ViewChild, HostListener, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

import { MdbSidenavComponent } from 'mdb-angular-ui-kit/sidenav';
import { fromEvent } from 'rxjs';
import { Router } from '@angular/router';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent implements OnInit, AfterViewInit, OnChanges {


  //UserApps : any;
  Logo: any;

  UserApps: any;
  data: any;

  companyForm: { companyId: string } = { companyId: '' };
  appForm: { appId: string } = { appId: '' }; // se puede Ajustar el tipo según lsd necesidades
  UserAppsOptions: any[] = []; // se puede Ajustar el tipo según lsd necesidades



  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.hidden = event.target.innerWidth >= 1400 ? false : true;
    //this.ngAfterViewInit()
  }

  @ViewChild('sidenav', { static: true }) sidenav!: MdbSidenavComponent;
  //mode = window.innerWidth >= 1400 ? 'side' : 'over';
  mode = 'over';
  //hidden = window.innerWidth >= 1400 ? false : true;
  hidden = false;
  title = 'my-app-angular';
  public isLoggedIn: boolean = false;
  menuData: string | null = null;
  //futureDates = new Date(new Date().setHours(0, 0, 0, 0));

  companies: any[] = [];
  apps: any[] = [];

  // Config Sideanv
  slim = true;
  slimCollapsed = true;
  slimWidth = 70;
  backdrop = false;
  closeOnEsc = false;

  bgSidenav = ''

  // Colores dinámicos
  primaryColor = ''
  secondaryColor = '';
  defaultColor = ''
  textLight = ''

  companyId = null
  appId: any = null
  appDefault: boolean = false;


  loadingCompanyApp = false;

  constructor(

    private router: Router,
    private authService: AuthService,
    private ngZone: NgZone) {
    this.companyForm = { companyId: localStorage.getItem('IdCompany') || '' }; // Recuperar el valor del localStorage
    this.appForm.appId = localStorage.getItem('appId') || ''; // Recuperar el valor del localStorage
    this.router.config.push({ path: '**', component: PageNotFoundComponent });
  }
  ngOnChanges(changes: SimpleChanges): void {
    throw new Error('Method not implemented.');
  }


  ngAfterViewInit() {
    if (this.sidenav) {
      this.ngZone.runOutsideAngular(() => {
        fromEvent(window, 'resize').subscribe(() => {
          if (window.innerWidth < 1400 && this.mode !== 'over') {
            this.ngZone.run(() => {
              this.mode = 'over';
              this.hideSidenav();
              //this.hidden = true;
            });
          } else if (window.innerWidth >= 1400 && this.mode !== 'side') {
            this.ngZone.run(() => {
              this.mode = 'side';
              this.showSidenav();
              //this.hidden = false;
            });
          }
        });
      });
    }
  }

  hideSidenav() {
    if (this.sidenav !== undefined)
      setTimeout(() => {
        this.sidenav.hide();
      }, 100);
  }

  showSidenav() {
    if (this.sidenav !== undefined)
      setTimeout(() => {
        this.sidenav.show();
      });
  }

  onCompanyChange(companyId: number) {
    const opcionesMenuString = localStorage.getItem('OpcionesMenu');

    if (opcionesMenuString) {
      const opcionesMenu = JSON.parse(opcionesMenuString);

      // Buscar las aplicaciones basadas en el IdCompany recibido
      const matchingApps = Object.values(opcionesMenu.UserMenu).find((company: any) => company.IdCompany === companyId * 1);

      if (matchingApps) {
        // Obtener directamente IdApp y AppName de UserMenu
        this.apps = Object.values(matchingApps).map((app: any) => ({
          value: app.IdApp,
          label: app.AppName
        }));
      }
    }
  }

  async checkAuthentication(): Promise<void> {
    const token = await this.authService.getToken();
    if (!token) {
      this.isLoggedIn = false;
      this.router.navigateByUrl('/login');
      // Aquí podrías redirigir al usuario a la página de inicio de sesión si lo deseas
    } else {
      this.isLoggedIn = true;
    }
  }
  async ngOnInit(): Promise<void> {

    //this.checkAuthentication();

    //this.futureDates.setDate(this.futureDates.getDate() + 1);
    const token = await this.authService.getToken();
    if (!token || token == 'false') {
      //location.href = '/login'
      this.authService.logout();
    } else {
      this.isLoggedIn = true;
      const userAppsString = localStorage.getItem('UserApps');
      if (userAppsString) {
        this.UserApps = JSON.parse(userAppsString);
        this.UserAppsOptions = this.UserApps.map((app: { value: { toString: () => any; }; label: any; }) => ({ value: app.value.toString(), label: app.label }));
      }



      const companyAppString = localStorage.getItem('CompanyApp');
      if (companyAppString) {
        const companyAppData = JSON.parse(companyAppString);
        const companies = companyAppData.COMPANIES;

        // Creamos un array para almacenar las empresas
        const companyList: any[] = [];

        // Iteramos sobre las empresas y agregamos sus datos al array
        Object.keys(companies).forEach(companyId => {
          const company = companies[companyId];
          companyList.push({
            value: company.IdCompany,
            label: company.COMPANYNAME
          });
        });

        // Asignamos el array de empresas a this.companies
        this.companies = companyList;

        this.data = companyAppString ? JSON.parse(companyAppString) : null;
        const company = this.data.COMPANIES[this.companyForm.companyId];

        // Obtener todas las aplicaciones de la empresa
        const apps = company.Apps;

        // Cargar todas las aplicaciones en el segundo select
        this.apps = apps.map((app: { AppID: any; APPNAME: any; }) => ({ value: app.AppID, label: app.APPNAME }));
      }




      this.getData();
    }

    const companyAppString = localStorage.getItem('CompanyApp');
    this.data = companyAppString ? JSON.parse(companyAppString) : null;

    //this.fillCompanyDropdown();


    // Llenar las opciones de UserApps si es necesario
    const userAppsString = localStorage.getItem('UserApps');
    if (userAppsString) {
      const userApps = JSON.parse(userAppsString);
      this.UserAppsOptions = userApps.map((app: { value: { toString: () => any; }; label: any; }) => ({ value: app.value.toString(), label: app.label }));
    }

    let Menu: any = {};
    const menuString = localStorage.getItem('Menu');
    if (menuString) {
      Menu = JSON.parse(menuString);
      // Colores dinámicos
      if (Menu && Menu.ColorConfig) {
        this.bgSidenav = Menu.ColorConfig.COLOR_POR_DEFECTO
        this.primaryColor = Menu.ColorConfig.COLOR_PRIMARIO
        this.secondaryColor = Menu.ColorConfig.COLOR_SECUNDARIO
        this.defaultColor = Menu.ColorConfig.COLOR_POR_DEFECTO
        this.textLight = Menu.ColorConfig.COLORES_TEXTO1
      }
    }


    // Obtener el valor del localStorage
    let menuStr = localStorage.getItem('Menu');

    if (menuStr) {
      try {
        // Convertir la cadena JSON a un objeto JavaScript
        var menuObjeto = JSON.parse(menuStr);

        // Extraer el valor de "IdApp"
        var idApp = menuObjeto.IdApp;

        this.appForm.appId = idApp + '';

      } catch (error) {
        console.error('Error al analizar JSON:', error);
      }
    } else {
    }


  }

  fillCompanyDropdown() {
    console.log("se hizo click");
    const companyAppString = localStorage.getItem('CompanyApp');
    this.data = companyAppString ? JSON.parse(companyAppString) : null;
    if (this.data && this.data.COMPANIES) {
      const companies = this.data.COMPANIES;
      Object.keys(companies).forEach(companyId => {
        const company = companies[companyId];
        if (company.Apps.some((app: { IS_DEFAULT: string }) => app.IS_DEFAULT === '1')) {
          this.companyForm = { companyId };
          this.fillAppDropdown(companyId); // Añadir esta línea para llenar también el dropdown de aplicaciones
          this.appDefault = true;
        }
      });
    }
  }

  fillAppDropdown(companyId: string) {

    localStorage.removeItem('IdCompany');
    localStorage.setItem('IdCompany', companyId);
    this.companyForm.companyId = companyId;
    this.appForm.appId = '0';
    this.appDefault = true;
    const companyAppString = localStorage.getItem('CompanyApp');
    this.data = companyAppString ? JSON.parse(companyAppString) : null;

    const selectedCompany = this.data?.COMPANIES[companyId];
    const apps = selectedCompany?.Apps;

    if (apps) {
      // Obtener las opciones para el segundo dropdown basado en IdCompany
      this.apps = apps.map((app: { AppID: string; APPNAME: string }) => ({
        value: app.AppID,
        label: app.APPNAME
      }));
    }


    //this.rebuildMenu(localStorage.getItem('appId') || '', companyId) 
    this.actualizarEstiloApp(companyId, false)
  }

  actualizarEstiloApp(companyId: any, updateLogo = false) {

    const opcionesMenuString = localStorage.getItem('CompanyApp');
    const opcionesMenu = opcionesMenuString ? JSON.parse(opcionesMenuString) : null;

    if (opcionesMenu) {
      const opcionesMenuArray = Object.keys(opcionesMenu.COMPANIES).map((key) => opcionesMenu.COMPANIES[key])
      const resultado = opcionesMenuArray.find(element => element.IdCompany == companyId);
      const colorConfig = resultado.ColorConfig;

      this.Logo = resultado.Logo

      if (colorConfig && updateLogo) {
        const cc_bgSidenav = colorConfig.COLOR_FONDO_MENU

        const cc_primaryColor = colorConfig.COLOR_PRIMARIO
        const cc_secondaryColor = colorConfig.COLOR_SECUNDARIO
        const cc_defaultColor = colorConfig.COLOR_POR_DEFECTO
        const cc_textLight = colorConfig.COLORES_TEXTO1

        this.bgSidenav = cc_bgSidenav

        this.primaryColor = cc_primaryColor
        this.secondaryColor = cc_secondaryColor
        this.defaultColor = cc_defaultColor
        this.textLight = cc_textLight
      }
    }
  }

  async getData(): Promise<any> {
    const menuString = localStorage.getItem('Menu'); // Obtiene la cadena del localStorage
    if (menuString !== null) {
      // Verifica si menuString no es null antes de intentar parsearlo
      try {
        this.menuData = JSON.parse(menuString);

        if (typeof this.menuData === 'object' && this.menuData !== null)
          this.Logo = (this.menuData as { Logo?: string }).Logo || '';

      } catch (error) {
        console.error('Error al analizar JSON del menú:', error);
      }
    }
  }

  logout(): void {
    this.isLoggedIn = false;
    this.authService.logout();
    this.router.navigateByUrl('/login');
  }

  async rebuildMenu(appId: string, companyId: string) {
    //localStorage.removeItem('Menu');
    this.loadingCompanyApp = true;
    let obj = {
      is_login: 0,
      id_user: localStorage.getItem('IdUser'), 
      id_company: companyId,
      id_app: appId
    }
    const responseMenu = await this.authService.getNewMenu(obj);

    if (responseMenu !== null) {
      
     
      const Menu = responseMenu;
      localStorage.setItem('Menu', JSON.stringify(Menu[1]));
    }


    //localStorage.removeItem('IdCompany');
    const opcionesMenuString = localStorage.getItem('OpcionesMenu');
    if (opcionesMenuString !== null) {
      const opcionesMenu = JSON.parse(opcionesMenuString);
      //localStorage.setItem('Menu', JSON.stringify(opcionesMenu.UserMenu[appId])); 

      localStorage.setItem('IdCompany', companyId/*JSON.stringify(opcionesMenu.UserMenu[selectedValue].IdCompany)*/);

      this.companyForm.companyId = companyId;

      const menuString = localStorage.getItem('Menu');

      localStorage.setItem('appId', appId); // Almacenar el valor en el localStorage
      this.appForm.appId = appId;


      if (menuString !== null) {
        // Parsear la cadena JSON
        const menuData = JSON.parse(menuString);
        console.log("menuData: ", menuData);
        // Acceder a la propiedad 'dashboard'
        const dashboardValue = menuData.Dashboard;
        // Hacer lo que necesites con 'dashboardValue'
        window.location.href = 'home';
      } else {
        console.error('No hay datos en localStorage para la clave "Menu".');
      }
    }

    this.actualizarEstiloApp(companyId,true)
  }


  onMenuClick(menu: any) {
    localStorage.setItem('IdMenu', menu.id);
  }
}


